import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.scss';

const SubscriptionStatus = ({ data }) => {
  const { subscriptionInfo, studentInfo } = data;

  return (
    <div className={styles.container}>
      <p>{subscriptionInfo.startDate}</p>
      <p>{subscriptionInfo.nextBillingDate}</p>
      <p>{studentInfo.endDate}</p>
      <p>{subscriptionInfo.renewalPrice}</p>
      <p>{subscriptionInfo.currency}</p>
    </div>
  );
};

SubscriptionStatus.propTypes = {
  data: PropTypes.shape({
    subscriptionInfo: PropTypes.shape({
      startDate: PropTypes.string,
      nextBillingDate: PropTypes.string,
      renewalPrice: PropTypes.number,
      currency: PropTypes.string
    }),
    studentInfo: PropTypes.shape({
      isStudent: PropTypes.bool,
      endDate: PropTypes.string
    })
  }).isRequired
};

export default SubscriptionStatus;
